import { HttpClient } from '../../httpClient'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type CreateAssetReferenceV1 = OpalApi<'CreateAssetReferenceV1', 201>
type CreateAssetReferenceV1ResponseData = OpalApiResponseDocument<
  'CreateAssetReferenceV1',
  201
>

export const createAssetReference: CreateAssetReferenceV1 = async ({
  requestBody,
}: Parameters<CreateAssetReferenceV1>[0] = {}) => {
  const url = new URL('/api/v1/asset_references', window.location.origin)

  return HttpClient()
    .post<CreateAssetReferenceV1ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
